import { IconComponent } from '../types'
import { cn } from '../utils/cn'

/** @public */
export const SVG: IconComponent = ({ children, className, ...props }) => (
  <svg
    className={cn('block', className)}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    {children}
  </svg>
)
